export const styles = {
  page: (isMobile) => ({
    padding: isMobile ? 18 : 28,
    flex: 1,
    minHeight: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    overflowY: "auto",
    background: "linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%)",
  }),
  headerRow: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "flex-start" : "center",
    gap: isMobile ? 10 : 14,
    marginBottom: 24,
  }),
  iconBadge: {
    width: 48,
    height: 48,
    borderRadius: 14,
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    boxShadow: "0 16px 32px rgba(31, 58, 112, 0.14)",
  },
  title: {
    margin: 0,
    fontSize: 22,
    color: "#1f3a70",
  },
  subtitle: {
    margin: "6px 0 0",
    fontSize: 14,
    color: "#5d6f8a",
    lineHeight: 1.5,
  },
  card: (isMobile) => ({
    width: "100%",
    background: "rgba(255,255,255,0.98)",
    borderRadius: 22,
    padding: isMobile ? 20 : 28,
    boxShadow: "0 20px 50px rgba(34, 60, 80, 0.08)",
    border: "1px solid rgba(31, 58, 112, 0.08)",
    boxSizing: "border-box",
  }),
  sectionHeader: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: "space-between",
    gap: 16,
    alignItems: "flex-start",
    marginBottom: 24,
  }),
  cardTitle: {
    margin: 0,
    fontSize: 18,
    color: "#15233c",
  },
  cardDescription: {
    margin: "8px 0 0",
    color: "#6a7c96",
    fontSize: 14,
  },
  tag: {
    display: "inline-flex",
    padding: "8px 14px",
    borderRadius: 999,
    background: "rgba(31, 58, 112, 0.08)",
    color: "#1f3a70",
    fontSize: 12,
    fontWeight: 700,
  },
  formGroup: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    marginBottom: 18,
  },
  label: {
    color: "#48627a",
    fontSize: 13,
    fontWeight: 600,
  },
  optionGroup: (isMobile) => ({
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(260px, 1fr))",
    gap: 10,
  }),
  optionButton: {
    width: "100%",
    padding: "12px 16px",
    borderRadius: 14,
    border: "1px solid rgba(31, 58, 112, 0.12)",
    background: "#ffffff",
    color: "#384765",
    cursor: "pointer",
    transition: "all 0.25s ease",
    textAlign: "left",
    fontWeight: 600,
    boxShadow: "0 4px 16px rgba(31, 58, 112, 0.04)",
    minWidth: 0,
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
  },
  optionButtonActive: {
    borderColor: "#1f3a70",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    boxShadow: "0 14px 30px rgba(31, 58, 112, 0.16)",
  },
  input: {
    width: "100%",
    minHeight: 46,
    padding: "12px 14px",
    borderRadius: 16,
    border: "1px solid rgba(31, 58, 112, 0.14)",
    fontSize: 14,
    color: "#223047",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  },
  textarea: {
    width: "100%",
    minHeight: 140,
    padding: "14px 16px",
    borderRadius: 18,
    border: "1px solid rgba(31, 58, 112, 0.14)",
    fontSize: 14,
    color: "#223047",
    resize: "vertical",
    outline: "none",
    boxSizing: "border-box",
    lineHeight: 1.6,
  },
  helpText: {
    marginTop: 4,
    color: "#7a8ba8",
    fontSize: 12,
  },
  submitButton: {
    width: "100%",
    marginTop: 6,
    padding: "14px 18px",
    borderRadius: 16,
    border: "none",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    boxShadow: "0 16px 30px rgba(31, 58, 112, 0.22)",
  },
};
